/* eslint react/no-find-dom-node: "off" */
/* eslint react/no-string-refs: "off" */
import React from 'react';
import ReactDOM from 'react-dom';
import * as _ from 'lodash';
import moment from 'moment';
import * as css from './gagestyle';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import {
  WORK_HOUR_ZONES,
  SPOT_STATUS,
  GATE_PASSAGES_STATUS_CODE,
  APPROVAL_STATUS,
} from '../../utilities/constants';
import { isApiFlagOn } from '../../utilities/commonUtil';
import {
  isTimeInsideLimit,
  formatTime,
  reduceTime24,
  timeIsNegative,
  convertDouble,
  convertMinToTime,
  convertTimeToMin,
} from '../../utilities/momentUtil';
import dialogLoader from '../../utilities/dialogLoader';
import EventMg, { EventType } from '../../utilities/EventManager';

const overtimeMin = 24 * 60;
const DRAGGABLE_ACTION_MOVE = 'MOVE';

/**
 * @description 作業時間取得
 */
const currentZoneTime = () => {
  const currentZone = SessionStorageService.getWorkHourZone();
  let currentWorkTime = {};
  if (currentZone === WORK_HOUR_ZONES.day.key) {
    currentWorkTime.start = SessionStorageService.getWorkStartTime();
    currentWorkTime.end = SessionStorageService.getWorkEndTime();
  }
  if (currentZone === WORK_HOUR_ZONES.night.key) {
    currentWorkTime.start = SessionStorageService.getWorkStartTimeNight();
    currentWorkTime.end = SessionStorageService.getWorkEndTimeNight();
  }
  if (currentZone === WORK_HOUR_ZONES.midnight.key) {
    currentWorkTime.start = SessionStorageService.getWorkStartTimeMidnight();
    currentWorkTime.end = SessionStorageService.getWorkEndTimeMidnight();
  }

  const currentStartTime = currentWorkTime.start;
  const currentEndTime = currentWorkTime.end;
  currentWorkTime.start = `${currentWorkTime.start.split(':')[0]}:00`;
  currentWorkTime.end =
    currentWorkTime.end.split(':')[1] === '00' ||
    currentStartTime === currentEndTime
      ? `${currentWorkTime.end.split(':')[0]}:00`
      : `${Number(currentWorkTime.end.split(':')[0]) + 1}:00`;
  return currentWorkTime;
};

/**
 * @description 日付跨ぎチェック
 * @param {string} startTime 開始時間
 * @param {string} endTime 終了時間
 * @param {boolean} isFieldWorkTime true: 現場作業時間, false: 予定作業時間, 禁止時間帯
 */
const straddleDay = (startTime, endTime, isFieldWorkTime) => {
  const startMins = moment.duration(startTime).asMinutes();
  const endMins = moment.duration(endTime).asMinutes();
  if (startMins >= endMins) {
    const hour = Number(endTime.split(':')[0]) + 24;
    return isFieldWorkTime ? `${hour}:00` : `${hour}:${endTime.split(':')[1]}`;
  } else {
    return endTime;
  }
};

/**
 * @description 時間分割処理
 * @param {string} time 時間
 */
const splitTime = time => {
  return `${time.split(':')[0]}:${time.split(':')[1]}`;
};

/**
 * @description 時 → 分変換 ※ 0:00が基準
 */
const convertTime24 = time => {
  return parseInt(time.split(':')[0]) >= 24
    ? `${parseInt(time.split(':')[0]) - 24}:${time.split(':')[1]}`
    : time;
};

//グリッド化
const convertGrid = (time, grid) => {
  let _time;
  if (convertDouble(Math.round(time.split(':')[1] / grid) * grid) === '60') {
    _time = `${convertDouble(parseInt(time.split(':')[0]) + 1)}:00`;
  } else {
    _time = `${convertDouble(time.split(':')[0])}:${convertDouble(
      Math.round(time.split(':')[1] / grid) * grid
    )}`;
  }
  return _time;
};

const GRID_SPACING = 15; // 15分
const roundScheduleTime = minutes => {
  let rounded = _.round(minutes / GRID_SPACING) * GRID_SPACING;
  return rounded;
};

/**
 * 左右伸縮判定位置とゲージ移動判定位置の間のスペースを返す
 */
const distanceBetweenMoveAndResizeItem = () => {
  const DEFAULT_DISTANCE = 10;
  return DEFAULT_DISTANCE;
};

/**
 * @description 時間バー_ヘッダー
 */
export const TimeBarHeader = ({ scheduleLimitTimes }) => {
  // 現場作業時間取得
  // eslint-disable-next-line no-unused-vars
  const getFieldWorkTime = ({ limit_start_time, limit_end_time }) => {
    let currentFieldWorkTime = currentZoneTime();
    currentFieldWorkTime.end = straddleDay(
      currentFieldWorkTime.start,
      currentFieldWorkTime.end,
      true
    );
    // 作業時間帯バー表示の開始と終了を00:00でそろえた場合, 00:00 ~ 24:00と表示する
    if (currentFieldWorkTime.start === currentFieldWorkTime.end) {
      if (currentFieldWorkTime.start === '00:00') {
        currentFieldWorkTime.end = '24:00';
      } else {
        // 00:00以外でもそろえた場合24時間表示
        currentFieldWorkTime.end = convertMinToTime(
          convertTimeToMin(currentFieldWorkTime.end) + 1440
        );
      }
    }

    return {
      start: currentFieldWorkTime.start, // 現場作業開始時間
      end: currentFieldWorkTime.end, // 現場作業終了時間
    };
  };

  // クラス名取得
  const getClassName = () => {
    const fieldWorkTimeRange =
      Number(fieldWorkTime.end.split(':')[0]) -
      Number(fieldWorkTime.start.split(':')[0]);
    return fieldWorkTimeRange > 20 ||
      (fieldWorkTime.start === '00:00' && fieldWorkTime.end === '00:00')
      ? `fulltime ${fieldWorkTimeRange}`
      : `${fieldWorkTimeRange}`;
  };

  const fieldWorkTime = getFieldWorkTime(scheduleLimitTimes[0]); // 現場作業時間

  return (
    <div className={getClassName()}>
      <BarLabel
        fieldWorkStartTime={convertTimeToMin(fieldWorkTime.start)}
        fieldWorkEndTime={convertTimeToMin(fieldWorkTime.end)}
      />
    </div>
  );
};

/**
 * @description 時間バー_ラベル
 * @param {number} fieldWorkStartTime 現場作業開始時間(分単位)
 * @param {number} fieldWorkEndTime 現場作業終了時間(分単位)
 */
export const BarLabel = props => {
  const { fieldWorkStartTime, fieldWorkEndTime } = props;
  let fieldWorkTime = {
    start: Number(fieldWorkStartTime), // 現場作業開始時間(分単位)
    end: Number(fieldWorkEndTime), // 現場作業終了時間(分単位)
  }; // 現場作業時間
  fieldWorkTime.range = fieldWorkTime.end - fieldWorkTime.start; // 現場作業時間範囲
  const gridHour = 1; // グリッド線間隔(時)
  const labelCount = Math.ceil(fieldWorkTime.range / 60 / gridHour) + 1; // ラベル数
  let labels = []; // ラベル

  for (let i = 0; i < labelCount; i += 1) {
    labels.push(convertMinToTime(fieldWorkTime.start + i * 60));
  }

  // テーブルヘッダーの時間帯のHHのみ表示させる(例：10:00 → 10)
  // 日跨ぎの場合 {時間 - 24} で表示する(例：36:00 → 12)
  const completeLabels = _.map(labels, value => {
    const timeHours = Number(value.split(':')[0]);
    return timeHours > 24 ? String(timeHours - 24) : String(timeHours);
  });

  return (
    <div className='gage-label'>
      {_.map(completeLabels, (label, index) => (
        <span className='gage-label__time' key={index}>
          {label}
        </span>
      ))}
    </div>
  );
};

/**
 * @description 時間バー1
 * @param {string} useStartTime 予定作業開始時間
 * @param {string} useEndTime 予定作業終了時間
 * @param {number} spotFlag 0: 通常, 1: スポット
 * @param {object} data 予定情報
 * @param {function} callback バー更新メソッド
 * @param {boolean} isForeman true: 職長, false: 職長以外
 * @param {boolean} isGate true: ゲート予定, false: ゲート予定以外
 * @param {array} scheduleLimitTimes 禁止時間帯
 * @param {boolean} viewOnlyFlag true: 操作不能, false: 操作可能
 * @param {boolean} isTimeBarReset 時間バーリセットフラグ true: 時間バーリセットを実行, false: 時間バーリセットを実行しない
 */
export const SchaduleBar = props => {
  const {
    useStartTime,
    useEndTime,
    spotFlag,
    data,
    callback,
    isForeman,
    isGate,
    scheduleLimitTimes,
    disabledTimes,
    viewOnlyFlag,
    isTimeBarReset,
    tableRef,
  } = props;

  let currentFieldWorkTime = currentZoneTime(); // 現場作業時間
  let isStraddleFieldDay =
    Number(currentFieldWorkTime.start.split(':')[0]) >
    Number(currentFieldWorkTime.end.split(':')[0]); // 現場作業時間_日付跨ぎフラグ
  currentFieldWorkTime.end = straddleDay(
    currentFieldWorkTime.start,
    currentFieldWorkTime.end,
    true
  );

  const scheduleStartTime = splitTime(useStartTime); // 予定作業開始時間
  let scheduleEndTime = splitTime(useEndTime); // 予定作業終了
  scheduleEndTime = straddleDay(scheduleStartTime, scheduleEndTime, false);

  // クラス名取得
  const getClassName = () => {
    if (isGate) {
      switch (data.status_code) {
        case GATE_PASSAGES_STATUS_CODE.carry.id:
          return spotFlag === SPOT_STATUS.spot.id
            ? 'gage--carryin gage--spot'
            : 'gage--carryin';
        case GATE_PASSAGES_STATUS_CODE.move.id:
          return spotFlag === SPOT_STATUS.spot.id
            ? 'gage--carryout gage--spot'
            : 'gage--carryout';
        case GATE_PASSAGES_STATUS_CODE.occupy.id:
          return spotFlag === SPOT_STATUS.spot.id
            ? 'gage--occupation gage--spot'
            : 'gage--occupation';
        default:
          return 'gage--carryin';
      }
    } else {
      if (spotFlag === SPOT_STATUS.spot.id) {
        return 'gage--spot';
      } else {
        return 'gage--carryin';
      }
    }
  };

  return (
    <div
      className='gage-grid-wrapper'
      style={{ overflow: 'hidden', backgroundColor: '#fff' }}
    >
      {(data.approval_flag === APPROVAL_STATUS.approval.id && isForeman) ||
      viewOnlyFlag ? (
        <StaticBar
          type={getClassName()}
          grid={GRID_SPACING}
          workStartTime={currentFieldWorkTime.start}
          workEndTime={currentFieldWorkTime.end}
          disabledTimes={disabledTimes}
          scheduleLimitTimes={scheduleLimitTimes}
          isStraddleFieldDay={isStraddleFieldDay}
          startTime={scheduleStartTime}
          endTime={scheduleEndTime}
          data={data}
          callback={callback}
          tableRef={tableRef}
        />
      ) : (
        <Bar
          type={getClassName()}
          grid={GRID_SPACING}
          workStartTime={currentFieldWorkTime.start}
          workEndTime={currentFieldWorkTime.end}
          disabledTimes={disabledTimes}
          scheduleLimitTimes={scheduleLimitTimes}
          isStraddleFieldDay={isStraddleFieldDay}
          isTimeBarReset={isTimeBarReset}
          startTime={scheduleStartTime}
          endTime={scheduleEndTime}
          data={data}
          callback={callback}
          tableRef={tableRef}
        />
      )}
    </div>
  );
};

/**
 * @description 時間バー2
 */
export class Bar extends React.Component {
  constructor(props) {
    super(props);

    this.component;
    this.barRef = React.createRef();
    this.gage;
    this.gageRef;
    this.timer;
    this.gridhour = 1; //グリッド線を何時間ごとに表示するか
    this.state = {
      id: props.data.id,
      left: 0,
      right: 0,
      grid: this.props.grid || GRID_SPACING, //吸着する分数
      rect: {},

      //現在の時間設定
      schedule: {
        start: convertTimeToMin(props.startTime),
        end:
          convertTimeToMin(this.props.endTime) <
          convertTimeToMin(this.props.startTime)
            ? convertTimeToMin(this.props.endTime) + 1440
            : convertTimeToMin(this.props.endTime),
      },
      isStraddleFieldDay: this.props.isStraddleFieldDay, // 現場作業時間_日付跨ぎフラグ
      mouseDown: false,
      updatedFlag: false, // バー更新フラグ
      isShortBar: false, // ドラッグ範囲が小さい
    };
    // handleGageUpdate
    this.callback = {
      updateLeft: this.updateLeft.bind(this),
      updateRight: this.updateRight.bind(this),
      updateScheduleCenter: this.updateScheduleCenter.bind(this),
      handleDragEnd: this.handleDragEnd.bind(this),
      showDialog: this.showDialog.bind(this),
      handleMouseDown: this.handleMouseDown.bind(this),
      handleMouseUp: this.handleMouseUp.bind(this),
      handleUpdate: this.handleUpdate.bind(this),
      gageUpdate: this.gageUpdate.bind(this),
    };
    //0-24時間が基準 分に変換して計算
    this.defaultRange = {
      start: 0,
      end: 24 * 60,
    };
    //時間範囲指定を格納 ここも分に変換
    this.currentRange = {
      start: convertTimeToMin(props.workStartTime),
      end: convertTimeToMin(props.workEndTime),
    };
    //日付またぎ
    if (this.currentRange.start >= this.currentRange.end) {
      this.currentRange.end += overtimeMin;
    }
    this.currentRange.total = this.currentRange.end - this.currentRange.start;

    //指定時間範囲内か判定
    this.diff = {
      start: this.diffTime(this.currentRange.start, this.state.schedule.start),
      end: this.diffTime(this.currentRange.end, this.state.schedule.end),
    };
  }

  componentDidMount() {
    // this.component = ReactDOM.findDOMNode(this.selfRef);
    this.component = this.barRef.current;
    this.gage = ReactDOM.findDOMNode(this.gageRef);
    this.setState({
      currentRange: this.currentRange,
    });
    this.update();
    window.addEventListener('resize', () => {
      this.handleUpdate();
    });
    EventMg.addEventListener(EventType.LAYOUT_UPDATE, () => {
      this.handleUpdate();
    });
    document.addEventListener('mousedown', e => {
      this.handleMouseDown(e);
    });
    document.addEventListener('mouseup', e => {
      this.handleMouseUp(e);
    });
    // 画面を横スクロールしてもバーがずれないために更新する
    window.addEventListener(
      'scroll',
      () => {
        this.handleUpdate();
      },
      true
    );
    this.setShortBar();
  }

  handleMouseDown() {
    this.setState({ mouseDown: true });
  }

  handleMouseUp() {
    this.setState({ mouseDown: false });
  }

  gageUpdate() {
    this.setState(
      {
        schedule: {
          start: convertTimeToMin(this.props.startTime),
          end:
            convertTimeToMin(this.props.endTime) <=
            convertTimeToMin(this.props.startTime)
              ? convertTimeToMin(this.props.endTime) + 1440
              : convertTimeToMin(this.props.endTime),
        },
        updatedFlag: true,
      },
      () => {
        this.setShortBar();
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.startTime !== this.props.startTime ||
      prevProps.endTime !== this.props.endTime ||
      this.props.updatedFlag === true ||
      this.props.isTimeBarReset
    ) {
      this.gageUpdate();
    }

    if (this.props.workStartTime && this.props.workEndTime) {
      this.currentRange = {
        start: convertTimeToMin(this.props.workStartTime),
        end: convertTimeToMin(this.props.workEndTime),
      };

      //日付またぎ
      if (this.currentRange.start >= this.currentRange.end) {
        this.currentRange.end += overtimeMin;
      }
      this.currentRange.total = this.currentRange.end - this.currentRange.start;

      //指定時間範囲内か判定
      this.diff = {
        start: this.diffTime(
          this.currentRange.start,
          this.state.schedule.start
        ),
        end: this.diffTime(this.currentRange.end, this.state.schedule.end),
      };
    }

    //バー外でマウスを離したらバグらないために更新する
    if (prevState.mouseDown !== this.state.mouseDown && !this.state.mouseDown) {
      this.handleUpdate();
    }

    if (this.state.updatedFlag) {
      this.handleUpdate();
      this.setState({ updatedFlag: false });
    }

    if (!_.isEqual(prevState.schedule, this.state.schedule)) {
      this.handleUpdate();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => {
      this.handleUpdate();
    });
  }

  handleUpdate() {
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => {
      this.update();
    }, 300);
  }

  update() {
    this.updateRect();
    this.setDefaultValue();
  }

  setDefaultValue() {
    //重要！！この関数はゲージの表示更新のメイン
    //分をピクセルに変換
    //スタート位置 >> スタート時間 - レンジ開始時間 = レンジからの経過時間
    const { schedule } = this.state;
    // 24時間が作業時間帯の最大なので、ゲージの時間が作業時間帯より早い場合は+24時間と判断する
    // 例：4:00 ~ 4:00作業時間帯の場合、3:00 ~ 3:45 = 27:00 ~ 27:45
    this.setState({
      schedule: {
        ...schedule,
        start:
          schedule.start < this.currentRange.start &&
          schedule.start + 1440 < this.currentRange.end
            ? schedule.start + 1440
            : schedule.start,
        end:
          schedule.end < this.currentRange.start &&
          schedule.start > this.currentRange.start
            ? schedule.end + 1440
            : schedule.end,
      },
    });
    schedule.start =
      schedule.start < this.currentRange.start &&
      schedule.start + 1440 < this.currentRange.end
        ? schedule.start + 1440
        : schedule.start;
    schedule.end =
      schedule.end < this.currentRange.start &&
      schedule.start > this.currentRange.start
        ? schedule.end + 1440
        : schedule.end;
    let _startMin = schedule.start - this.currentRange.start;
    let _endMin =
      schedule.start >= schedule.end
        ? schedule.end + 1440 - this.currentRange.start
        : schedule.end - this.currentRange.start;

    //時間を全体の割合に変換
    const _startRate = _startMin / this.currentRange.total;
    const _endRate = _endMin / this.currentRange.total;

    //ピクセルに変換
    const componentRect = this.component.getBoundingClientRect();
    const _startPix = Math.ceil(componentRect.width * _startRate);
    const _endPix = Math.floor(componentRect.width * (1.0 - _endRate));

    this.setState({
      left: _startPix,
      right: _endPix,
    });
  }

  diffTime(defaultTime, useTime) {
    let time = moment
      .duration(useTime, 'minutes')
      .subtract(defaultTime, 'minutes');
    const isNegative = time.asMinutes() < 0;
    const hours = Math.abs(time.hours());
    const minutes = Math.abs(time.minutes());
    const formatted = `${isNegative ? '-' : ''}${hours}:${minutes}`;
    return formatted;
  }

  handleDragEnd(action) {
    this.updateScheduleCenter(action);
  }

  updateLeft(n) {
    this.setState({ left: n });
  }

  updateRight(n) {
    this.setState({ right: n });
  }

  updateRect() {
    const _rect = this.component.getBoundingClientRect();
    this.setState({ rect: _rect });
  }

  async updateScheduleCenter(action = '') {
    this.updateRect();
    const gagerect = this.gage.getBoundingClientRect();

    //ピクセル
    const startPix = gagerect.left - this.state.rect.left;
    const endPix =
      gagerect.left +
      gagerect.width -
      (this.state.rect.left + this.state.rect.width);

    //率
    const startRate = (startPix / this.state.rect.width) * 100;
    const endRate =
      ((this.state.rect.width + endPix) / this.state.rect.width) * 100;

    //分
    const startMin = this.currentRange.total * (startRate / 100);
    const endMin = this.currentRange.total * (endRate / 100);

    //変更した予定を分に変換
    const schedule = { ...this.state.schedule };
    schedule.start = this.currentRange.start + startMin;
    schedule.end =
      this.currentRange.start + endMin < schedule.start
        ? this.currentRange.start + endMin + 1440
        : this.currentRange.start + endMin;

    //変更した予定を時間に変換
    let totalStartTime = convertMinToTime(schedule.start);
    let totalEndTime = convertMinToTime(schedule.end);

    //TODO:ここで固定グリッドの時間に変換
    totalStartTime = convertGrid(totalStartTime, this.state.grid);
    totalEndTime = convertGrid(totalEndTime, this.state.grid);

    // 開始、終了時間の間隔が15分の時、時間帯バーの移動操作で開始、終了時間が同じになることがあったため対策
    if (totalStartTime === totalEndTime) {
      schedule.end += GRID_SPACING;
      totalEndTime = convertGrid(
        convertMinToTime(schedule.end),
        this.state.grid
      );
    }

    /**
     * 時間帯バーの移動時、開始時間と終了時間の差が変化していないかを確認
     * 変化していたら終了時間に変化分を加える
     */
    if (action === DRAGGABLE_ACTION_MOVE) {
      const adjustSchedule = this.adjustBarTime({
        start: convertTimeToMin(totalStartTime),
        end: convertTimeToMin(totalEndTime),
      });

      if (!_.isEqual(schedule, adjustSchedule)) {
        totalStartTime = convertGrid(
          convertMinToTime(adjustSchedule.start),
          this.state.grid
        );
        totalEndTime = convertGrid(
          convertMinToTime(adjustSchedule.end),
          this.state.grid
        );
      }
      this.setState({ schedule: adjustSchedule });
    } else {
      this.setState({ schedule });
    }

    //グリッドからMin変換
    let totalStartTimeGridMin = convertTimeToMin(totalStartTime);
    let totalEndTimeGridMin = convertTimeToMin(totalEndTime);

    if (Number(totalStartTime.split(':')[0]) >= 24) {
      totalStartTime = `${Number(totalStartTime.split(':')[0]) - 24}:${
        totalStartTime.split(':')[1]
      }`;
      if (totalStartTime.split(':')[0].length === 1) {
        totalStartTime = `0${totalStartTime}`;
      }
    }

    if (Number(totalEndTime.split(':')[0]) >= 24) {
      totalEndTime = `${Number(totalEndTime.split(':')[0]) - 24}:${
        totalEndTime.split(':')[1]
      }`;
      if (totalEndTime.split(':')[0].length === 1) {
        totalEndTime = `0${totalEndTime}`;
      }
    }

    if (this.props.callback) {
      let response = await this.props.callback(this.props.data, {
        start: `${totalStartTime}:00`,
        end: `${totalEndTime}:00`,
      });
      if (response) {
        this.setState({
          schedule: {
            start: totalStartTimeGridMin,
            end: totalEndTimeGridMin,
          },
        });
        //指定時間範囲内か判定
        this.diff = {
          start: this.diffTime(
            this.currentRange.start,
            this.state.schedule.start
          ),
          end: this.diffTime(this.currentRange.end, this.state.schedule.end),
        };
        //座標に変換
        this.setDefaultValue();
      }
    }
  }

  DisableArea() {
    const { currentRange } = this;
    const limit_times = _.map(this.props.disabledTimes, val => {
      const limitStartTime = splitTime(val.limit_start_time);
      let limitEndTime = splitTime(val.limit_end_time);

      //分をピクセルに変換
      const limitTime = {
        start: convertTimeToMin(limitStartTime),
        end: convertTimeToMin(limitEndTime),
      };

      let _startMin = limitTime.start - currentRange.start;
      if (_startMin < 0) {
        _startMin += 1440;
      }
      // console.log('currentRange:', this.currentRange);
      let _endMin = currentRange.end - limitTime.end;
      if (_endMin > 1440) {
        _endMin -= 1440;
      }

      //時間を全体の割合に変換
      const _startRate = _startMin / currentRange.total;
      const _endRate = _endMin / currentRange.total;

      //ピクセルに変換
      let _startPix = 0;
      let _endPix = 0;
      if (this.component) {
        const componentRect = this.component.getBoundingClientRect();
        _startPix = Math.ceil(componentRect.width * _startRate);
        // _endPix = Math.floor(componentRect.width * (1.0 - _endRate));
        _endPix =
          componentRect.width - Math.floor(componentRect.width * _endRate);
      }

      let _val = val;
      _val.left = _startPix;
      _val.right = _endPix;
      return _val;
    });

    const areaStyle = val => {
      return {
        backgroundColor: 'rgba(0,0,0,.16)',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: val.left + 1,
        right: val.right,
        zIndex: 1,
        width: Math.abs(val.right - (val.left + 1)),
        pointerEvents: 'none',
      };
    };

    const preStyle = val => {
      let limitStartTime = splitTime(val.limit_start_time);
      let limitEndTime = splitTime(val.limit_end_time);
      const limitTime = {
        start: convertTimeToMin(limitStartTime),
        end: convertTimeToMin(limitEndTime),
      };
      const preLeft =
        this.component &&
        Math.ceil(
          (this.component.getBoundingClientRect().width *
            (limitTime.start - this.currentRange.start)) /
            this.currentRange.total
        );
      const preRight =
        this.component &&
        this.component.getBoundingClientRect().width -
          Math.floor(
            this.component.getBoundingClientRect().width *
              ((this.currentRange.end - limitTime.end) /
                this.currentRange.total)
          );
      return {
        backgroundColor: 'rgba(0,0,0,.16)',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: preLeft,
        right: preRight,
        zIndex: 1,
        width: Math.abs(preRight - preLeft),
        pointerEvents: 'none',
      };
    };

    return _.map(limit_times, (val, index) => {
      if (
        formatTime(val.limit_start_time).isBefore(
          formatTime(this.props.scheduleLimitTimes[0].limit_start_time)
        ) &&
        formatTime(val.limit_end_time).isAfter(
          formatTime(this.props.scheduleLimitTimes[0].limit_start_time)
        )
      ) {
        return (
          <div>
            <div
              className='disable-area'
              key={`key_${index}-id_${val.id}-pre`}
              style={preStyle(val)}
            />
            <div
              className='disable-area'
              key={`key_${index}-id_${val.id}`}
              style={areaStyle(val)}
            />
          </div>
        );
      }
      return (
        <div
          className='disable-area'
          key={`key_${index}-id_${val.id}`}
          style={areaStyle(val)}
        />
      );
    });
  }

  /* eslint-disable no-unused-vars */

  async showDialog(id, target) {
    if (this.props.data.approval_flag) {
      return;
    }

    let options = [];
    // 開始時間と終了時間を外す
    let { limit_start_time, limit_end_time } = this.props.scheduleLimitTimes[0];
    let limitStart = moment(limit_start_time, 'HH:mm:ss');
    let limitStartMin = moment
      .duration(limit_start_time, 'HH:mm:ss')
      .asMinutes();
    let limitEnd = moment(limit_end_time, 'HH:mm:ss');
    if (limitEnd.isBefore(limitStart)) {
      limitEnd.add(24, 'hours');
    }
    let limitRange = moment.duration(limitEnd.diff(limitStart)).asMinutes();
    // 作業時間帯の開始時間、終了時間が同じ場合24時間設定にする
    if (limitRange === 0) {
      limitRange = 1440;
    }
    // const n = this.currentRange.total / 15;
    const n = limitRange / GRID_SPACING;
    for (let i = 0; i <= n; i++) {
      options.push({
        time: moment(
          convertTime24(
            convertMinToTime(
              convertTimeToMin(
                this.props.scheduleLimitTimes[0].limit_start_time
              ) +
                i * GRID_SPACING
            )
          ),
          'H:mm'
        ).format('HH:mm'),
        min: limitStartMin + i * GRID_SPACING,
      });
    }

    dialogLoader.show(BarInputDialog, {
      callback: {
        submit: (start, end, id, data) => {
          dialogLoader.close();
          // ドロップダウンが同じ場合、24時間対応にする
          if (parseInt(start) >= parseInt(end) && parseInt(end) < 1440) {
            end = parseInt(end, 10) + 1440;
            end = String(end);
          }
          let schedule = { start, end };
          /////
          let totalStartTime = convertMinToTime(schedule.start);
          let totalEndTime = convertMinToTime(schedule.end);

          //TODO:ここで固定グリッドの時間に変換
          totalStartTime = convertGrid(totalStartTime, this.state.grid);
          totalEndTime = convertGrid(totalEndTime, this.state.grid);

          //グリッドからMin変換
          let totalStartTimeGridMin = convertTimeToMin(totalStartTime);
          let totalEndTimeGridMin = convertTimeToMin(totalEndTime);

          if (Number(totalStartTime.split(':')[0]) >= 24) {
            totalStartTime = `${Number(totalStartTime.split(':')[0]) - 24}:${
              totalStartTime.split(':')[1]
            }`;
            if (totalStartTime.split(':')[0].length === 1) {
              totalStartTime = `0${totalStartTime}`;
            }
          }

          if (Number(totalEndTime.split(':')[0]) >= 24) {
            totalEndTime = `${Number(totalEndTime.split(':')[0]) - 24}:${
              totalEndTime.split(':')[1]
            }`;
            if (totalEndTime.split(':')[0].length === 1) {
              totalEndTime = `0${totalEndTime}`;
            }
          }
          /////
          setTimeout(async () => {
            if (this.props.callback) {
              let response = await this.props.callback(this.props.data, {
                start: `${totalStartTime}:00`,
                end: `${totalEndTime}:00`,
                // start: convertMinToTime(start) + ':00',
                // end: convertMinToTime(end) + ':00',
              });
              if (response) {
                this.setState({
                  schedule: {
                    start: totalStartTimeGridMin,
                    end: totalEndTimeGridMin,
                  },
                });
                this.diff = {
                  start: this.diffTime(
                    this.currentRange.start,
                    this.state.schedule.start
                  ),
                  end: this.diffTime(
                    this.currentRange.end,
                    this.state.schedule.end
                  ),
                };
                this.setDefaultValue();
              }
            }
          }, 1);
        },
      },
      state: {
        id,
        data: this.props.data,
        schedule: this.state.schedule,
        range: this.currentRange,
        options,
      },
    });
  }

  /**
   * 時間帯バー移動時の操作性向上用classを付与するかの判定
   * 操作性向上用classはgage.scssの&--expand関連
   *
   * 時間帯バーが短いかはcurrentZoneTimeで変わる基準だが、
   * classの有無で時間帯の計算に影響がないので付与範囲を広めにとっている
   *
   * 計算処理に影響がでた場合は取り除き、別の方法で操作性向上をする
   */
  setShortBar = () => {
    // 編集不可の時は付与しない
    if (isApiFlagOn(this.props.data.approval_flag)) {
      return this.setState({
        isShortBar: false,
      });
    }

    // 1時間内のゲージバーに付与
    if (
      Math.abs(this.state.schedule.start - this.state.schedule.end) <=
      GRID_SPACING * 4
    ) {
      return this.setState({
        isShortBar: true,
      });
    }
    if (this.state.isShortBar) {
      return this.setState({
        isShortBar: false,
      });
    }
  };

  /**
   * 時間帯バー移動時、開始時間と終了時間の差が変化していないかを確認する
   * 変化していたら終了時間に変化分の時間を加えたscheduleを返す
   */
  adjustBarTime = newSchedule => {
    const prevTime = Math.abs(
      this.state.schedule.start - this.state.schedule.end
    );
    const newTime = Math.abs(newSchedule.start - newSchedule.end);

    if (prevTime !== newTime) {
      return {
        ...newSchedule,
        end: newSchedule.end + (prevTime - newTime),
      };
    }

    return newSchedule;
  };

  /* eslint-ebable no-unused-vars */

  render() {
    const startPosition = () => {
      const { left, right, schedule, currentRange } = this.state;
      return !timeIsNegative(this.diff.start)
        ? currentRange && schedule.start >= currentRange.end
          ? { position: 'absolute', right: -right, color: 'inherit' }
          : {
              position: 'absolute',
              left:
                !_.isNull(this.barRef.current) &&
                this.barRef.current.offsetWidth - left > 51 // 40px + 11 margin-right
                  ? 0
                  : 'inherit',
              right:
                !_.isNull(this.barRef.current) &&
                this.barRef.current.offsetWidth - left > 51 // 40px + 11 margin-right
                  ? 'inherit'
                  : 0,
              color: 'inherit',
            }
        : schedule.start <= schedule.end
        ? { position: 'absolute', left: -left, color: 'inherit' }
        : { color: 'inherit' };
    };
    const startDiffShow = () => {
      if (timeIsNegative(this.diff.start)) {
        const t = this.diff.start.match(/.*(\d+):(\d+)/);
        if (parseInt(t[1]) === 0 && parseInt(t[2]) === 0) {
          return { display: 'none', color: 'red' };
        } else {
          return { display: 'inline', color: '#E64E17' };
        }
      } else {
        if (
          this.state.currentRange &&
          this.state.schedule.start >= this.state.currentRange.end
        ) {
          return {
            display: 'inline',
            color: '#E64E17',
          };
        } else {
          return { display: 'none' };
        }
      }
    };
    const endPosition = () => {
      const { left, right, schedule, currentRange } = this.state;
      // console.log(this.props.tableRef.current.offsetWidth, right);
      return !timeIsNegative(this.diff.end)
        ? { position: 'absolute', right: -right, color: 'inherit' } // 終了時間が時間帯より後
        : currentRange && schedule.end <= currentRange.start
        ? { position: 'absolute', left: -left, color: 'inherit' } // 終了時間が時間帯より前
        : {
            position: 'absolute',
            left:
              !_.isNull(this.barRef.current) &&
              this.barRef.current.offsetWidth - right > 51 // 40px + 11 margin-right
                ? 'inherit'
                : 0,
            right:
              !_.isNull(this.barRef.current) &&
              this.barRef.current.offsetWidth - right > 51 // 40px + 11 margin-right
                ? 0
                : 'inherit',
            color: 'inherit',
          }; // 時間帯内
    };
    const endDiffShow = () => {
      if (
        timeIsNegative(this.diff.end) &&
        this.state.schedule.start !== this.state.schedule.end
      ) {
        if (
          this.state.currentRange &&
          this.state.schedule.end <= this.state.currentRange.start
        ) {
          return { display: 'inline', color: '#E64E17' };
        } else {
          return { display: 'none' };
        }
      } else {
        const t = this.diff.end.match(/.*(\d+):(\d+)/);
        if (t) {
          if (
            parseInt(t[1]) === 0 &&
            parseInt(t[2]) === 0 &&
            this.state.schedule.start !== this.state.schedule.end
          ) {
            return { display: 'none' };
          } else {
            return { display: 'inline', color: '#E64E17' };
          }
        } else {
          return { display: 'inline', color: '#E64E17' };
        }
      }
    };
    const startTime = convertGrid(
      convertMinToTime(this.state.schedule.start),
      this.state.grid
    );
    const startDiffTime = convertGrid(this.diff.start, this.state.grid);
    const endTime = convertGrid(
      convertMinToTime(this.state.schedule.end),
      this.state.grid
    );
    const endDiffTime = convertGrid(this.diff.end, this.state.grid);

    const convertTime24 = time => {
      return parseInt(time.split(':')[0]) >= 24
        ? `${convertDouble(
            String(parseInt(time.split(':')[0]) - 24)
          )}:${convertDouble(time.split(':')[1])}`
        : time;
    };

    const grid = 100 / (this.currentRange.total / 60);

    const expandClass = this.state.isShortBar ? 'gage__bar--expand' : '';
    return (
      <div
        className='gage-grid'
        style={{
          userSelect: 'none',
        }}
        // ref={e => {
        //   this.selfRef = e;
        // }}
        ref={this.barRef}
      >
        {_.times(this.currentRange.total / 60 + 1, n => {
          return (
            <div
              style={{
                position: 'absolute',
                left: `${n * grid}%`,
                width: 1,
                height: '100%',
                borderLeft: '1px dashed #707070',
                zIndex: 1,
              }}
              key={n}
            />
          );
        })}
        <DraggableLeft
          callback={this.callback}
          scheduleLimitTimes={this.props.scheduleLimitTimes}
          dialogDisabled={isApiFlagOn(this.props.data.approval_flag)}
          {...this.state}
        />
        <Gage
          ref={e => {
            this.gageRef = e;
          }}
          defaultValue={this.state.schedule}
          callback={this.callback}
          type={this.props.type}
          {...this.state}
          scheduleLimitTimes={this.props.scheduleLimitTimes}
          dialogDisabled={isApiFlagOn(this.props.data.approval_flag)}
          tableRef={this.props.tableRef}
        >
          <div
            className='gage__time-start'
            style={{ position: 'relative', height: '24px' }}
          >
            <span style={startPosition()}>
              {convertTime24(startTime)}
              <span style={startDiffShow()}>
                (
                {this.state.currentRange &&
                this.state.schedule.start < this.state.currentRange.start
                  ? '-'
                  : '+'}
                {this.state.currentRange &&
                this.state.schedule.start < this.state.currentRange.start
                  ? convertMinToTime(
                      this.state.currentRange.start - this.state.schedule.start
                    )
                  : this.state.currentRange
                  ? convertMinToTime(
                      this.state.schedule.start - this.state.currentRange.end
                    )
                  : startDiffTime}
                )
              </span>
            </span>
            {/*
            // 差分表示に不具合があるために表示させない BLDE_V2-13942 など
            <span style={startDiffShow()}>(b{startDiffTime})</span>
            */}
          </div>
          <div className={`gage__bar ${expandClass}`} />
          <div
            className='gage__time-end'
            style={{ position: 'relative', height: '24px' }}
          >
            <span style={endPosition()}>
              {convertTime24(endTime)}
              <span style={endDiffShow()}>
                (
                {this.state.currentRange &&
                this.state.schedule.end <= this.state.currentRange.start
                  ? ''
                  : '+'}
                {this.state.currentRange &&
                this.state.schedule.end <= this.state.currentRange.start
                  ? convertMinToTime(
                      this.state.schedule.end - this.state.currentRange.start
                    )
                  : endDiffTime}
                )
              </span>
            </span>
          </div>
        </Gage>
        <DraggableRight
          callback={this.callback}
          scheduleLimitTimes={this.props.scheduleLimitTimes}
          dialogDisabled={isApiFlagOn(this.props.data.approval_flag)}
          {...this.state}
        />
        {this.DisableArea()}
      </div>
    );
  }
}

export class GatekeeperBar extends React.Component {
  getBar() {
    //const schedule = this.props.scheduleLimitTimes[0];
    const usestart = this.props.in_datetime;
    const useend = this.props.out_datetime;
    const currentTime = moment().format('HH:mm');
    let currentWorkTime = currentZoneTime();
    const workStartTime = currentWorkTime.start;
    let workEndTime = currentWorkTime.end;
    const startTime = usestart
      ? `${usestart.split(':')[0]}:${usestart.split(':')[1]}`
      : '6:00';
    let endTime = useend
      ? `${useend.split(':')[0]}:${useend.split(':')[1]}`
      : currentTime;

    //開始が空の場合はnullを返す
    if (!usestart) {
      //return null;
    }

    //日付またぎ
    const start = convertTimeToMin(workStartTime);
    const end = convertTimeToMin(workEndTime);
    if (start > end) {
      const h = parseInt(workEndTime.split(':')[0]) + 24;
      workEndTime = `${h}:${workEndTime.split(':')[1]}`;
    }

    //稼働時間が日付またぎ
    const _start = parseInt(startTime.split(':')[0]);
    const _end = parseInt(endTime.split(':')[0]);
    if (_start > _end) {
      const _h = parseInt(endTime.split(':')[0]) + 24;
      endTime = `${_h}:${endTime.split(':')[1]}`;
    }

    return this.props.bar({
      type: 'gage--entered', //ゲージの種類/cssのクラス名
      grid: GRID_SPACING, //吸着する分の単位
      workStartTime, //始業時間
      workEndTime, //就業時間
      startTime, //予定開始時間
      endTime, //予定終了時間
    });
  }

  render() {
    return (
      <div style={{ overflow: 'hidden', backgroundColor: '#ffffff' }}>
        {' '}
        {this.getBar()}{' '}
      </div>
    );
  }
}

export class StaticBar extends Bar {
  render() {
    const startPosition = () => {
      return timeIsNegative(this.diff.start)
        ? { position: 'absolute', left: -this.state.left, color: 'inherit' }
        : { color: 'inherit' };
    };
    const startDiffShow = () => {
      if (timeIsNegative(this.diff.start)) {
        const t = this.diff.start.match(/.*(\d+):(\d+)/);
        if (parseInt(t[1]) === 0 && parseInt(t[2]) === 0) {
          return { display: 'none' };
        } else {
          return { display: 'inline', color: '#E64E17' };
        }
      } else {
        return { display: 'none' };
      }
    };
    const endPosition = () => {
      return !timeIsNegative(this.diff.end)
        ? { position: 'absolute', right: -this.state.right, color: 'inherit' }
        : { color: 'inherit' };
    };
    const endDiffShow = () => {
      if (timeIsNegative(this.diff.end)) {
        return { display: 'none' };
      } else {
        const t = this.diff.end.match(/.*(\d+):(\d+)/);
        if (t) {
          if (parseInt(t[1]) === 0 && parseInt(t[2]) === 0) {
            return { display: 'none' };
          } else {
            return { display: 'inline', color: '#E64E17' };
          }
        } else {
          return { display: 'inline', color: '#E64E17' };
        }
      }
    };
    const startTime = convertGrid(
      convertMinToTime(this.state.schedule.start),
      this.state.grid
    );
    const startDiffTime = convertGrid(this.diff.start, this.state.grid).replace(
      '-',
      '+'
    );
    const endTime = convertGrid(
      convertMinToTime(this.state.schedule.end),
      this.state.grid
    );
    const endDiffTime = convertGrid(this.diff.end, this.state.grid);
    const convertTime24 = time => {
      return parseInt(time.split(':')[0]) >= 24
        ? `${parseInt(time.split(':')[0]) - 24}:${time.split(':')[1]}`
        : time;
    };

    const grid = 100 / (this.currentRange.total / 60);
    return (
      <div
        className='gage-grid'
        style={{
          userSelect: 'none',
        }}
        // ref={e => {
        //   this.selfRef = e;
        // }}
        ref={this.barRef}
      >
        {_.times(this.currentRange.total / 60 + 1, n => {
          return (
            <div
              style={{
                position: 'absolute',
                left: `${n * grid}%`,
                width: 1,
                height: '100%',
                borderLeft: '1px dashed #707070',
                zIndex: 1,
              }}
              key={n}
            />
          );
        })}
        <Gage
          ref={e => {
            this.gageRef = e;
          }}
          defaultValue={this.state.schedule}
          callback={this.callback}
          type={this.props.type}
          disabled
          dialogDisabled
          {...this.state}
        >
          <div
            className='gage__time-start'
            style={{ position: 'relative', height: '24px' }}
          >
            <span style={startPosition()}>
              {convertTime24(startTime)}
              {/*
              // 差分表示に不具合があるために表示させない BLDE_V2-13942 など
              <span style={startDiffShow()}>(a{startDiffTime})</span>
              */}
            </span>
          </div>
          <div className='gage__bar' />
          <div
            className='gage__time-end'
            style={{ position: 'relative', height: '24px' }}
          >
            <span style={endPosition()}>
              {convertTime24(endTime)}
              <span style={endDiffShow()}>(+{endDiffTime})</span>
            </span>
          </div>
        </Gage>
        {this.DisableArea()}
      </div>
    );
  }
}

/**
 * ダイアログ
 */
export class BarInputDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      start: '',
      end: '',
    };

    this.InputDialogTime = this.InputDialogTime.bind(this);
    this.handleStartChange = this.handleStartChange.bind(this);
    this.handleEndChange = this.handleEndChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      start: this.props.dialog.state.schedule.start,
      end:
        this.props.dialog.state.schedule.end >
        this.props.dialog.state.schedule.start
          ? this.props.dialog.state.schedule.end
          : this.props.dialog.state.schedule.end + 1440,
    });
  }

  InputDialogTime(options, isStart) {
    // 開始時間選択の場合、作業時間帯の終了時間を見せない、終了時間選択の場合、作業時間帯の開始時間を見せない
    return _.map(options, (option, index) => {
      if (
        isStart &&
        option.min >= this.state.end &&
        option.min >= this.props.dialog.state.range.start
      ) {
        return '';
      } else if (
        !isStart &&
        option.min <= this.state.start &&
        option.min <= this.props.dialog.state.range.end
      ) {
        return '';
      } else {
        return (
          <option key={index} value={option.min}>
            {option.time}
          </option>
        );
      }
    });
  }

  handleStartChange(e) {
    const start = parseInt(e.target.value);
    this.setState({
      start,
    });
  }

  handleEndChange(e) {
    const end = parseInt(e.target.value);
    this.setState({
      end,
    });
  }

  render() {
    const { schedule, options, data, range } = this.props.dialog.state;
    const timeStart = convertMinToTime(reduceTime24(this.state.start));
    const timeEnd = convertMinToTime(reduceTime24(this.state.end));

    return (
      <div className='dialog-md dialog--modal'>
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>時間入力</span>
        </div>
        <div className='dialog-md__body'>
          <div className='dialog-form'>
            <div className='dialog-form__item'>
              <div className='dialog-form__label --col-xs-5 --col-md-5 --col-lg-5 --col-xl-5'>
                <span className='label'>開始時間 </span>
              </div>
              <div className='dialog-form__element --col-xs-7 --col-md-7 --col-lg-7 --col-xl-7'>
                <div className='form-element'>
                  <select
                    ref='start'
                    onChange={e => this.handleStartChange(e)}
                    value={roundScheduleTime(this.state.start)}
                  >
                    {this.state.start !== '' &&
                      this.state.end !== '' &&
                      (this.state.start < options[0].min ||
                        this.state.start > options[options.length - 1].min) && (
                        <option
                          disabled
                          hidden
                          value={roundScheduleTime(this.state.start)}
                        >
                          {timeStart}
                        </option>
                      )}
                    {this.InputDialogTime(options, true)}
                  </select>
                </div>
              </div>
            </div>
            <div className='dialog-form__item'>
              <div className='dialog-form__label --col-xs-5 --col-md-5 --col-lg-5 --col-xl-5'>
                <span className='label'>終了時間</span>
              </div>
              <div className='dialog-form__element --col-xs-7 --col-md-7 --col-lg-7 --col-xl-7'>
                <div className='form-element'>
                  <div className='form-element__element'>
                    <select
                      ref='end'
                      onChange={e => this.handleEndChange(e)}
                      value={roundScheduleTime(this.state.end)}
                    >
                      {this.state.start !== '' &&
                        this.state.end !== '' &&
                        (this.state.end > options[options.length - 1].min ||
                          this.state.end < options[0].min) && (
                          <option
                            disabled
                            hidden
                            value={roundScheduleTime(this.state.end)}
                          >
                            {timeEnd}
                          </option>
                        )}
                      {this.InputDialogTime(options, false)}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            className='btn-fixedsize--sub'
            onClick={() => {
              dialogLoader.close();
            }}
          >
            戻る
          </button>
          <button
            className='btn-fixedsize--effective'
            onClick={() => {
              this.props.dialog.callback.submit(
                this.refs.start.value,
                this.refs.end.value,
                this.props.dialog.state.id,
                this.props.dialog.state.data
              );
            }}
          >
            更新
          </button>
        </div>
      </div>
    );
  }
}

class Draggable extends React.Component {
  constructor(props) {
    super(props);
    this.selfRef = React.createRef();
    this.component;
    this.isMoving = false;
    this.distance = 0;
    this.margin_x = 0;
    this.prev = { points: { x: 0, y: 0 } };
    this.move = { points: { x: 0, y: 0 } };
    this.gridCounter = 0;
    this.state = { style: {} };
    this.dragFlag = false; //ドラッグの判定
    this.action = {
      leave: 'scale(1,1)',
      drag: 'scale(15,1)',
    };
    this.disable = props.disabled || false;
    this.DragStart = this.DragStart.bind(this);
    this.DragMove = this.DragMove.bind(this);
    this.DragEnd = this.DragEnd.bind(this);
    this.transformOrigin = '';
  }

  componentDidMount() {
    // this.component = ReactDOM.findDOMNode(this.selfRef);
    this.component = this.selfRef.current;
  }

  //サブクラスでオーバーライド
  setStyle(move) {}

  SetRef(e) {
    this.selfRef = e;
  }

  DragStart(e) {
    if (!this.props.dialogDisabled) {
      e.target.style.transformOrigin = ''; // MouseEnter時に付与したのstyleを解除
      this.prev.points = _.cloneDeep({ x: e.clientX, y: e.clientY });
      this.isMoving = true;
    }
  }

  DragMove(e) {
    // マウスホバーでも有効されるのでクリックしてない場合returnする
    if (!this.props.mouseDown) {
      return;
    }
    if (!this.disable && this.isMoving && this.props.mouseDown) {
      this.move.points = _.cloneDeep({ x: e.clientX, y: e.clientY });
      let moveLength = this.move.points.x - this.prev.points.x;
      this.setStyle(moveLength);
      this.prev.points = _.cloneDeep({ x: e.clientX, y: e.clientY });
    }
  }

  DragEnd(e, action = '') {
    if (!this.disable && this.isMoving) {
      this.isMoving = false;
      this.move.points = _.cloneDeep({ x: e.clientX, y: e.clientY });
      let moveLength = this.move.points.x - this.prev.points.x;
      this.setStyle(moveLength);
      this.prev.points = _.cloneDeep({ x: e.clientX, y: e.clientY });
      if (this.props.callback.handleDragEnd) {
        this.props.callback.handleDragEnd(action);
      }
    }
  }

  getStyle() {
    const _style = _.cloneDeep(this.state.style);
    return _style;
  }

  isDisabled = () => {
    if (this.disable || this.props.dialogDisabled) {
      return true;
    }
    return false;
  };

  MouseEnter = e => {
    // LeftDraggable、 RightDraggable
    if (this.transformOrigin !== '' && !this.props.mouseDown) {
      e.target.style.transform = this.action.enter;
      e.target.style.transformOrigin = this.transformOrigin;
    }
  };
  MouseLeave = e => {
    if (this.isDisabled()) {
      return;
    }
    e.target.style.transform = this.action.leave;
  };

  render() {
    return (
      <div
        style={this.getStyle()}
        ref={e => this.SetRef(e)}
        onMouseDown={this.DragStart}
        onMouseMove={this.DragMove}
        onMouseUp={this.DragEnd}
        onMouseEnter={this.MouseEnter}
        onMouseLeave={this.MouseLeave}
      />
    );
  }
}

class Gage extends Draggable {
  componentDidMount() {
    super.componentDidMount();

    //座標をリセット
    let style = _.cloneDeep(css.gage);
    style.left = 0;
    style.right = 0;

    if (this.disable) {
      style.cursor = 'default';
    }

    this.setState({
      style,
      left: 0,
      right: 0,
      defaultValue: this.props.defaultValue,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { left, right } = this.props;

    if (right !== prevState.right || left !== prevState.left) {
      let style = _.cloneDeep(prevState.style);
      style.left = left;
      style.right = right;
      if (this.disable) {
        style.cursor = 'default';
      }
      this.setState({
        style,
        left,
        right,
      });
    }

    if (
      JSON.stringify(this.props.defaultValue) !==
      JSON.stringify(prevState.defaultValue)
    ) {
      this.setState({ defaultValue: this.props.defaultValue });
    }
  }

  DragStart(e) {
    this.dragFlag = false;
    super.DragStart(e);
  }

  DragMove(e) {
    this.dragFlag = true;
    super.DragMove(e);
  }

  DragEnd(e) {
    if (!this.dragFlag && !this.props.dialogDisabled) {
      // ゲージが変更される前にダイアログが表示されるためtimeoutする
      setTimeout(() => {
        this.props.callback.showDialog(this.props.id, e.target); //ダイアログ表示
      }, 200);
      this.dragFlag = false;
      this.isMoving = false;
      return;
    }
    super.DragEnd(e, DRAGGABLE_ACTION_MOVE);
  }

  setStyle(move) {
    let { limit_start_time, limit_end_time } = this.props.scheduleLimitTimes[0];
    if (limit_start_time === '00:00:00' && limit_end_time === '00:00:00') {
      limit_end_time = '24:00:00';
    }
    //ドラッグ・時間の調節で設定で指定した下限・上限を超えることがないように修正 BLDE_V2-16062
    // 作業開始時間を「分」に変更 ex: 10:00 → 600
    // 15分、30分差分は出来ないのでcurrentRangeから引く
    let startMin =
      convertTimeToMin(limit_start_time) - this.props.currentRange.start;
    // 作業終了時間を「分」に変更 ex: 19:00 → 1140
    // 15分、30分差分は出来ないのでcurrentRangeから引く
    let endMin =
      this.props.currentRange.end > 1440
        ? this.props.currentRange.end - 1440 - convertTimeToMin(limit_end_time)
        : this.props.currentRange.end - convertTimeToMin(limit_end_time);
    // 1時間 = グラフのXパーセントを計算する ex: 11:00 ~ 19:00の場合 X = 1/9 = 11.11111%
    // グラフのX%から移動可能になるように設定する
    let limitLeft =
      (startMin / this.props.currentRange.total) * this.props.rect.width;
    let limitRight =
      (endMin / this.props.currentRange.total) * this.props.rect.width;
    let style = _.cloneDeep(this.state.style);
    style.left = style.left + move;
    style.right = style.right - move;
    // 時間が期間の前・後にドラッグ出来ないようにする
    if (style.left < limitLeft) {
      style.left = limitLeft;
      style.right = style.right + move;
    }
    if (style.right < limitRight) {
      style.right = limitRight;
      style.left = style.left - move;
    }
    this.setState({ style });
    this.props.callback.updateLeft(style.left);
    this.props.callback.updateRight(style.right);
  }

  getStyle() {
    const _style = _.cloneDeep(css.gage);
    if (this.isDisabled()) {
      _style.cursor = 'default';
    }
    _style.transform = this.action.leave;
    _style.left = this.props.left;
    _style.right = this.props.right + 2;
    return _style;
  }

  render() {
    return (
      <div
        className={this.props.type}
        style={this.getStyle()}
        ref={e => this.SetRef(e)}
        onMouseDown={this.DragStart}
        onMouseMove={this.DragMove}
        onMouseUp={this.DragEnd}
      >
        {this.props.children}
      </div>
    );
  }
}

class DraggableLeft extends Draggable {
  constructor(props) {
    super(props);
    let style = _.cloneDeep(css.draggableLeft);
    if (this.disable) {
      style.cursor = 'default';
    }
    this.state = { style };
    // マウスをホバーしたらCSS変更
    this.action.enter = 'scale(3,1) translateX(-2px)';
    this.action.leave = 'scale(1,1) translateX(-8px)';
    this.transformOrigin = 'right center';
  }

  componentDidMount() {
    let style = _.cloneDeep(this.state.style);
    style.left = this.props.left;
    this.setState({
      style,
      left: this.props.left,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.left !== prevProps.left) {
      const left = this.props.left;
      this.setState({
        style: {
          ...this.state.style,
          left,
        },
        left,
      });
    }
  }

  DragStart(e) {
    if (this.dragFlag) {
      this.dragFlag = false;
      super.DragStart(e);
      e.target.style.transform = this.action.drag;
    }
  }

  DragMove(e) {
    this.dragFlag = true;
    super.DragMove(e);
  }

  DragEnd(e) {
    if (!this.dragFlag && !this.props.dialogDisabled) {
      // ゲージが変更される前にダイアログが表示されるためtimeoutする
      setTimeout(() => {
        this.props.callback.showDialog(this.props.id, e.target); //ダイアログ表示
      }, 200);
      this.dragFlag = false;
      this.isMoving = false;
      return;
    }
    super.DragEnd(e);
  }

  setStyle(move) {
    if (this.isMoving) {
      const { currentRange, rect, left, right, callback } = this.props;
      const { limit_start_time } = this.props.scheduleLimitTimes[0];
      const startMin = convertTimeToMin(limit_start_time) - currentRange.start;
      const limitLeft = (startMin / currentRange.total) * rect.width;
      const limitRight =
        rect.width - (GRID_SPACING / currentRange.total) * rect.width - right;
      let style = _.cloneDeep(this.state.style);
      // style.left += style.left >= 0 ? move : 0;
      style.left = style.left + move;
      if (style.left <= limitLeft) {
        style.left = limitLeft;
      }
      if (style.left >= limitRight) {
        style.left = limitRight;
      }
      this.setState({ style });
      callback.updateLeft(style.left);
    }
  }

  getStyle() {
    const _style = _.cloneDeep(this.state.style);
    if (this.isDisabled()) {
      _style.cursor = 'default';
    }
    const { left, right, schedule } = this.props;
    // 数値ではなくautoの場合はDraggableのgetStyleを使用する
    if (!_.isNumber(left) || !_.isNumber(right) || !_.isNumber(_style.left)) {
      return super.getStyle();
    }
    _style.left -= distanceBetweenMoveAndResizeItem(schedule);
    return _style;
  }
}

class DraggableRight extends Draggable {
  constructor(props) {
    super(props);
    let style = _.cloneDeep(css.draggableRight);
    if (this.disable) {
      style.cursor = 'default';
    }
    this.state = { style };
    this.action.enter = 'scale(3,1) translateX(2px)';
    this.action.leave = 'scale(1,1) translateX(8px)';
    this.transformOrigin = 'left center';
  }

  componentDidMount() {
    let style = _.cloneDeep(this.state.style);
    style.right = this.props.right;
    this.setState({
      style,
      right: this.props.right,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.right !== prevProps.right) {
      const right = this.props.right;
      this.setState({
        style: {
          ...this.state.style,
          right,
        },
        right,
      });
    }
  }

  DragStart(e) {
    if (this.dragFlag) {
      this.dragFlag = false;
      super.DragStart(e);
      e.target.style.transform = this.action.drag;
    }
  }

  DragMove(e) {
    this.dragFlag = true;
    super.DragMove(e);
  }

  DragEnd(e) {
    if (!this.dragFlag && !this.props.dialogDisabled) {
      e.target.style.transform = this.action.leave;

      // ゲージが変更される前にダイアログが表示されるためtimeoutする
      setTimeout(() => {
        this.props.callback.showDialog(this.props.id, e.target); //ダイアログ表示
      }, 200);
      this.dragFlag = false;
      this.isMoving = false;
      return;
    }
    super.DragEnd(e);
  }

  setStyle(move) {
    if (this.isMoving) {
      const { currentRange, rect, left, right, callback } = this.props;
      let {
        limit_start_time,
        limit_end_time,
      } = this.props.scheduleLimitTimes[0];
      if (limit_start_time === '00:00:00' && limit_end_time === '00:00:00') {
        limit_end_time = '24:00:00';
      }
      const endMin =
        currentRange.end > 1440
          ? currentRange.end - 1440 - convertTimeToMin(limit_end_time)
          : currentRange.end - convertTimeToMin(limit_end_time);
      const limitRight = (endMin / currentRange.total) * rect.width;
      const limitLeft =
        rect.width - (GRID_SPACING / currentRange.total) * rect.width - left;
      const style = _.cloneDeep(this.state.style);
      // style.right -= style.right >= 0 ? move : 0;
      style.right = style.right - move;
      if (style.right >= limitLeft) {
        style.right = limitLeft;
      }
      if (style.right <= limitRight) {
        style.right = limitRight;
      }
      this.setState({ style });
      callback.updateRight(style.right);
    }
  }
  getStyle() {
    const _style = _.cloneDeep(this.state.style);
    if (this.isDisabled()) {
      _style.cursor = 'default';
    }
    const { left, right, schedule } = this.props;

    // 数値ではなくautoの場合はDraggableのgetStyleを使用する
    if (!_.isNumber(left) || !_.isNumber(right) || !_.isNumber(_style.right)) {
      return super.getStyle();
    } else {
      _style.right -= distanceBetweenMoveAndResizeItem(schedule);
    }

    return _style;
  }
}



// WEBPACK FOOTER //
// ./src/components/gagebar/bar.jsx